var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pickup-address-map')
}
var staticRenderFns = []

export { render, staticRenderFns }